import React from 'react';
import Select from 'react-select';
import { emphasize, makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import {
  Control, NoOptionsMessage, Placeholder, Option, Menu, ValueContainer
} from './index';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 'auto'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
  },
  chip: {
    margin: theme.spacing(0.5, 0.25)
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2)
  },
  placeholder: {
    position: 'absolute',
    bottom: 6
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  divider: {
    height: theme.spacing(2)
  }
}));

function SingleValue(props) {
  const {
    selectProps, innerProps, children
  } = props;
  return (
    <Typography data-id="singleValue" className={selectProps.classes.singleValue} {...innerProps}>
      {children}
    </Typography>
  );
}

SingleValue.propTypes = {
  children: PropTypes.node
};

SingleValue.defaultProps = {
  children: []
};


const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
};


export const CTSUMuiSingleSelect = ({
  options,
  value,
  onChange,
  onInputChange,
  name,
  title,
  isValid,
  disabled,
  appendBody,
  className
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      '& input': {
        font: 'inherit'
      }
    }),
    menuPortal: base => ({
      ...base
      // , minWidth: '300px !important'
    })
  };

  const clsName = disabled ? 'Mui-disabled-style' : '';
  return (
    <Select
      classes={classes}
      styles={selectStyles}
      inputId="react-select-single"
      isValid={isValid}
      isClearable
      data-id={name}
      isDisabled={disabled}
      name={name}
      title={title}
      value={value}
      options={options}
      onChange={onChange}
      onInputChange={onInputChange}
      components={components}
      classNamePrefix="reactSelect"
      className={`input-react-select ${clsName} ${className} reactSelect-wrapper`}
      menuPortalTarget={appendBody === true ? document.querySelector('body') : ''}
    />
  );
};
